import { ACTION } from './types';
import { ROUTE } from '../../../routes';
import { DigioKycStatus, ImportScriptSrc, } from '../../../configs/constants';
import { getDigio, nextStepCredStepper, } from '../../../configs/utils';
import { api } from '../../../configs/api';
import SharedPropsService from '../../../SharedPropsService';
import { APP_CONFIG, getAppHeader } from '../../../configs/config';
let pollInterval;
export const AadharInitAction = async (action, _datastore, { navigate, setDatastore, importScript, network, digio, showPopup }) => {
    await setDatastore(ROUTE.KYC_DIGILOCKER, 'continue', {
        loading: true,
    });
    const user = await SharedPropsService.getUser();
    const applicationId = user.linkedApplications[0].applicationId;
    importScript(ImportScriptSrc.DIGIO_SCRIPT, getDigio, async (digio_response) => {
        clearInterval(pollInterval);
        network
            .get(`${api.digioKycCheckRequestStatusOnCallBack}${applicationId}`, {
            headers: await getAppHeader(),
        })
            .then(async (response) => {
            if (response.status === 200 &&
                response.data.stepResponseObject ===
                    DigioKycStatus.COMPLETED) {
                const user = await SharedPropsService.getUser();
                user.linkedApplications[0] =
                    response.data.updatedApplicationObj;
                await SharedPropsService.setUser(user);
                await showPopup({
                    type: 'SUCCESS',
                    title: 'KYC done successfully',
                    // subTitle:
                    //     "Interest charges will be deducted automatically every month.",
                    ctaLabel: 'Continue',
                    shouldAutoNavigate: true,
                    primary: true,
                    ctaAction: {
                        routeId: ROUTE.KYC_DIGILOCKER,
                        type: ACTION.SUCCESS_VERIFICATION,
                        payload: {},
                    },
                });
            }
        });
    }, async (response) => {
        clearInterval(pollInterval);
        network
            .get(`${api.digioKycCheckRequestStatusOnCallBack}${applicationId}`, {
            headers: await getAppHeader(),
        })
            .then(async (response) => {
            if (response.status === 200) {
                if (response.data.stepResponseObject ===
                    DigioKycStatus.CREATED) {
                    await setDatastore(ROUTE.KYC_DIGILOCKER, 'continue', {
                        loading: false,
                    });
                }
                else if (response.data.stepResponseObject ===
                    DigioKycStatus.EXPIRED ||
                    response.data.stepResponseObject ===
                        DigioKycStatus.FAILED) {
                    console.log('Failure Digio_Response', response);
                    await showPopup({
                        type: 'FAILED',
                        title: 'Something went wrong',
                        // subTitle:
                        //     "Interest charges will be deducted automatically every month.",
                        ctaLabel: 'Try again',
                        primary: true,
                        ctaAction: {
                            routeId: ROUTE.KYC_DIGILOCKER,
                            type: ACTION.FAILED_VERIFICATION,
                            payload: {},
                        },
                    });
                }
            }
        });
    });
    // Digio Kyc Mandate
    await network
        .get(`${api.digioKycInitiateRequest}${applicationId}`, {
        headers: await getAppHeader(),
    })
        .then(response => {
        if (response.status === 200) {
            if (response.data && response.data.stepResponseObject) {
                const requestId = response.data.stepResponseObject.requestId;
                const tokenId = response.data.stepResponseObject.tokenId;
                digio.init();
                // console.log("RequestId: ", requestId);
                // console.log("PhoneNumber: ", user.user.phoneNumber);
                // console.log("tokenId: ", tokenId);
                digio.submit(requestId, user.user.phoneNumber, tokenId);
                //polling
                pollInterval = setInterval(async () => {
                    network
                        .get(`${api.digioKycCheckRequestStatus}${applicationId}`, {
                        headers: await getAppHeader(),
                    }, async () => { return; }, {
                        disableDefault: true
                    })
                        .then(async (res) => {
                        if (res &&
                            res.data &&
                            res.data.stepResponseObject ===
                                DigioKycStatus.COMPLETED) {
                            const user = await SharedPropsService.getUser();
                            user.linkedApplications[0] =
                                response.data.updatedApplicationObj;
                            await SharedPropsService.setUser(user);
                            clearInterval(pollInterval);
                            await showPopup({
                                type: 'SUCCESS',
                                title: 'KYC done successfully',
                                subTitle: "You will be redirected to the next step in a few seconds",
                                ctaLabel: 'Continue',
                                shouldAutoNavigate: true,
                                primary: true,
                                ctaAction: {
                                    routeId: ROUTE.KYC_DIGILOCKER,
                                    type: ACTION.SUCCESS_VERIFICATION,
                                    payload: {},
                                },
                            });
                            await setDatastore(ROUTE.KYC_DIGILOCKER, 'continue', {
                                loading: false,
                            });
                        }
                        else if ((res &&
                            res.data &&
                            res.data.stepResponseObject ===
                                DigioKycStatus.EXPIRED) ||
                            res.data.stepResponseObject ===
                                DigioKycStatus.FAILED) {
                            showPopup({
                                type: 'FAILED',
                                title: 'Something went wrong',
                                // subTitle:
                                //     "Interest charges will be deducted automatically every month.",
                                ctaLabel: 'Try again',
                                primary: true,
                                ctaAction: {
                                    routeId: ROUTE.KYC_DIGILOCKER,
                                    type: ACTION.FAILED_VERIFICATION,
                                    payload: {},
                                },
                            });
                            console.log('Verification Failed');
                            clearInterval(pollInterval);
                            await setDatastore(ROUTE.KYC_DIGILOCKER, 'continue', {
                                loading: false,
                            });
                        }
                    });
                }, APP_CONFIG.POLLING_INTERVAL);
            }
        }
    })
        .catch(error => {
        console.log(error);
    });
};
export const GoBackAction = async (action, _datastore, { goBack }) => {
    await goBack();
};
export const failedVerification = async (action, _datastore, { goBack, hidePopup }) => {
    await hidePopup();
};
export const successVerification = async (action, _datastore, { goBack, navigate, setDatastore }) => {
    await setDatastore(ROUTE.DIGIO_AGREEMENT_SIGN, "DigioAgreementPage", {
        loading: false
    });
    const routeObj = await nextStepCredStepper();
    navigate(routeObj.routeId, routeObj.params);
};
